<template>
  <section class="yellow-section">
    <b-container>
      <b-row>
        <b-col sm="12" class="section-container section-icon-container" @mousemove="tiltIcons">
          <img class="section-icon vet-clinic" src="../assets/img/Vet-clinic.svg" alt="Image">
          <img class="section-icon dog-walk" src="../assets/img/Dog walk.svg" alt="Image" >
          <h4 class="main-title-section">
            {{$t('text_yellow_section')}}
          </h4>
          <img class="section-icon shelter" src="../assets/img/Shelter.svg" alt="Image">
          <img class="section-icon shop" src="../assets/img/Shop.svg" alt="Image">
          <img class="section-icon park" src="../assets/img/Park.svg" alt="Image">
          <!--<div class="section-btn-container">-->
          <!--  <p class="info-text">{{$t('coming_soon')}}</p>-->
          <!--  <b-button class="purple-btn" v-b-modal.modal-center>{{$t('get_notified')}}</b-button>-->
          <!--</div>-->
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    tiltIcons (event) {
      const icons = document.querySelectorAll('.section-icon')
      icons.forEach((icon) => {
        const iconRect = icon.getBoundingClientRect()
        const iconCenterX = iconRect.left + iconRect.width / 2
        const mouseX = event.clientX
        const angle = (mouseX - iconCenterX) / 10
        icon.style.transform = `rotate(${angle}deg)`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.yellow-section{
  background: #FFDC5D;
  padding-top: 80px;
  padding-bottom: 80px;
  overflow: hidden;
  .section-container{
    position: relative;
    .main-title-section{
      max-width: 808px;
      width: 100%;
      color: #7A7CE8;
      text-align: center;
      font-family: $main-font;
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      margin: 0 auto;
      @media screen and (min-width: 320px) {
        font-size: 24px;
      }
      @media screen and (min-width: 768px) {
      }
      @media screen and (min-width: 992px) {
        font-size: 32px;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
    .section-icon{
      position: absolute;
    }
    .vet-clinic{
      width: 93px;
      height: 93px;
      left: -15px;
      top: -15px;
      @media screen and (min-width: 320px) {
        top: -80px;
      }
      @media screen and (min-width: 992px) {
        display: block;
        top: -15px;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
    .dog-walk{
      width: 85px;
      height: 85px;
      left: -50px;
      bottom: 15px;
      @media screen and (min-width: 320px) {
        bottom: 0;
      }
      @media screen and (min-width: 992px) {
        display: block;
        bottom: 15px;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
    .shelter{
      width: 115px;
      height: 115px;
      right: 0;
      top: -80px;
      @media screen and (min-width: 320px) {
        display: none;
      }
      @media screen and (min-width: 992px) {
        display: block;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
    .shop{
      width: 85px;
      height: 85px;
      right: -40px;
      bottom: 25px;
      @media screen and (min-width: 320px) {
        display: none;
      }
      @media screen and (min-width: 992px) {
        display: block;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
    .park{
      width: 63px;
      height: 63px;
      right: 17%;
      bottom: -15px;
      @media screen and (min-width: 320px) {
        right: 0;
        bottom: -50px;
      }
      @media screen and (min-width: 992px) {
        right: 17%;
        bottom: -15px;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
    .section-btn-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 32px;
      .info-text{
        color: #7A7CE8;
        text-align: center;
        font-family: $main-font;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 0;
      }
    }
  }
}
.section-icon {
  transition: transform 0.3s ease;
  transform-origin: center;
}

.yellow-section:hover .section-icon {
  transform: rotate(10deg);
}
</style>
